import React, { useEffect, useState } from "react";
import { IoMdStar } from "react-icons/io";
import "../Css/CustomersReviews.css";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { get } from "../apiService";
import { Divider } from "antd";
import { Fade } from "react-awesome-reveal";
const CustomersReviews = () => {
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    fetchReviews(pagination.current, pagination.pageSize);
  }, []);

  const fetchReviews = async (current, pageSize) => {
    setLoading(true);
    try {
      const action = "fetch";
      const response = await get(
        `/review.php?limit=${pageSize}&page=${current}&action=${action}`
      );
      setReviews(response.list);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current,
        pageSize,
        total: response.total,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="sectionDiv testimonialSection">
      <div className="container">
        <h3 className="text-center home-about-us-title ">
          What our client say's
        </h3>
        <div className="home-about-us-line-outer-ant">
          <div className="home-about-us-line-inner-ant">
            <Divider />
          </div>
          <div className="home-about-us-dot-ant">
            <label>•</label>
          </div>
          <div className="home-about-us-line-inner-ant">
            <Divider />
          </div>
        </div>

        <div className="testimonialList">
        <Fade triggerOnce direction="up">
          <Swiper
            loop={true}
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 2,
                spaceBetween: 50,
              },
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            navigation={true}
            modules={[Navigation]}
            className="mySwiper"
          >
            {reviews.map((val, index) => (
              <SwiperSlide key={index} className="p-3">
                <div className="testimonialCard">
                  <div className="reviewIcon">
                    {(() => {
                      const elements = [];
                      for (let i = 0; i < val?.rate; i++) {
                        elements.push(
                          <span key={i}>
                            <IoMdStar />
                          </span>
                        );
                      }
                      return elements;
                    })()}
                  </div>
                  <h5>{val.title}</h5>
                  <p>{val.description}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          </Fade>
        </div>
      </div>
    </section>
  );
};

export default CustomersReviews;
